/**
 *    @author:
 *    @since:
 *
 */

import { ViewportScroller } from '@angular/common';
import { Util } from 'src/refresh/service/Util';
import { IValidator } from '../_common/component/IValidator';
import { Setup4Component} from './setup_4.component';

export class Setup4Validation extends IValidator {

      constructor(private component: Setup4Component,private menuID:number) {
            super();
            this.birthType   = this.component.data.eligibility.birthType;
            this.deliveredByOther = this.component.data.eligibility.deliveredByOther;
            this.viewportScroller = this.component.viewportScroller;
      }
      private viewportScroller:ViewportScroller;
      private birthType:string = "";         // is multipleBirth?
      private deliveredByOther:string = "";  // otherThanDoctor?


      private success: boolean;

      public validate(): boolean {
          this.success = true;

          if(Util.isEmpty(this.component.eligibility.birthType)){
               this.focus("birthType","select_birthTypeSelect").error_invalidBirthType = "setup_4.error_invalidBirthType";
          }

          if(Util.isEmpty(this.component.eligibility.deliveredByOther)){
               this.focus("deliveredByOther","radio_deliveredByOtherRadio_0").error_invalidDeliveredByOther = "setup_4.error_invalidDeliveredByOther";
          }

          return this.success;
     }


     private jumpToError(tagId: string) : Setup4Component {
          if ( this.success ){
              this.scrollAndFocus(tagId);
              this.success = false;
          }
         
          return this.component;
     }

     private scrollAndFocus(tagId: string){
          let  content = this.component.elRef.nativeElement.querySelector('#'+tagId).parentElement;
          if ( content ) { 
               content.scrollIntoView({behavior: "smooth"});
               content.focus();
          }
     }

     private focus(tagId:string,ctrlId:string) : Setup4Component {
      if ( this.success ) {
           this.viewportScroller.scrollToAnchor(tagId);
           let ctrl = document.getElementById(ctrlId);
           ///console.log(ctrl);
           if ( ctrl ) ctrl.focus();
      }
           
      this.success = false;
      return this.component;
     }

     public IdOfChanged():number { 

      if (  this.birthType !=  this.component.data.eligibility.birthType ||
            this.deliveredByOther !=  this.component.data.eligibility.deliveredByOther) return this.menuID;

        return 0;   
     }

}
